export const Cookie = {
  topLevelDomain: true,

  set(name: string, value: string, days: number, domain?: string) {
    const cookie: any = { [name]: value, path: '/', sameSite: 'Lax', };

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      cookie.expires = date.toUTCString();
    }

    if (Cookie.topLevelDomain) {
      cookie.domain = `${window.location.hostname.split('.').slice(-2).join('.')}`;
    }

    if (domain) {
      cookie.domain = domain;
    }

    const arr = [];
    for (const key in cookie) {
      if (Object.prototype.hasOwnProperty.call(cookie, key)) {
        arr.push(`${key}=${cookie[key]}`);
      }
    }
    document.cookie = arr.join('; ');

    return this.get(name);
  },

  getAll() {
    const cookie: any = {};
    document.cookie.split(';').forEach((el) => {
      const [k, v] = el.split('=');
      cookie[k.trim()] = v;
    });
    return cookie;
  },

  get(name: any) {
    return this.getAll()[name];
  },

  remove(name: any) {
    this.set(name, '', -1);
  }

};
